import React from "react";
import { Helmet } from "react-helmet-async";

export default function HelmetMetaData(props) {
  const currentUrl = window.location.href;

  // Destructure with default values for props
  const {
    quote = "",
    title = "Handmade Indian Jewelry & Artisanal Crafts",
    image = "/public/logo192.png",
    description = "Shop handmade Indian jewelry, textiles & artisanal crafts from independent curators nationwide. Authentic, quality-checked pieces. Shop now.",
    hashtag = "",
    favIcon = "/public/logo192.png",
    // themeColor = "#ffffff",
    // storeLink,
  } = props;

  // useEffect(() => {
  //   const manifestData = {
  //     id: "/",
  //     orientation: "portrait",
  //     name: title,
  //     short_name: `${title} App`,
  //     description,
  //     start_url: `https://${storeLink}`,
  //     display: "standalone",
  //     theme_color: themeColor,
  //     background_color: "#f0f0f0",
  //     icons: [{ src: favIcon || "/public/logo192.png" }],
  //     display_override: ["window-controls-overlay"],
  //     protocol_handlers: [{ protocol: "mailto", url: "/newEmail?to=%s" }],
  //     shortcuts: [
  //       {
  //         name: "Wcommerce Partner Short",
  //         short_name: "Partner",
  //         description: "A sample PWA app",
  //         url: "/",
  //         icons: [{ src: favIcon || "/public/logo192.png" }],
  //       },
  //     ],
  //     screenshots: [
  //       {
  //         src: favIcon || "/public/logo192.png",
  //         type: "image/png",
  //         description: "PWABuilder Home Screen",
  //       },
  //     ],
  //   };

  //   const blob = new Blob([JSON.stringify(manifestData)], {
  //     type: "application/json",
  //   });
  //   const manifestURL = URL.createObjectURL(blob);

  //   let manifestElement = document.querySelector('link[rel="manifest"]');
  //   if (!manifestElement) {
  //     manifestElement = document.createElement("link");
  //     manifestElement.rel = "manifest";
  //     document.head.appendChild(manifestElement);
  //   }
  //   manifestElement.href = manifestURL;

  //   return () => {
  //     if (manifestElement) {
  //       document.head.removeChild(manifestElement);
  //     }
  //     URL.revokeObjectURL(manifestURL);
  //   };
  // }, [title, description, themeColor, storeLink, favIcon]);

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={favIcon} />
      <link rel="apple-touch-icon" href={favIcon} />

      {/* Meta Tags for SEO */}
      <meta name="description" content={description} />

      {/* Canonical Link */}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Meta Tags for Social Media Preview */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:type" content="image/*" />
      <meta property="og:site_name" content="Wcommerce" />
      <meta property="og:hashtag" content={hashtag} />
      <meta property="og:quote" content={quote} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:hashtag" content={hashtag} />
      <meta name="twitter:creator" content="@camperstribe" />
    </Helmet>
  );
}
